import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { hotlineOfferDescriptionStyle } from '@/feature/hotline/component/HotlineOfferDescription/style';
/**
 * 相談オファーについての説明コンポーネント
 */
export const HotlineOfferDescription = (props) => {
    const { className = '', items, title } = props;
    const style = hotlineOfferDescriptionStyle();
    return (_jsxs("dl", Object.assign({ className: style.base({ class: className }) }, { children: [_jsx("dt", Object.assign({ className: style.title() }, { children: title })), _jsx("dt", Object.assign({ className: style.content() }, { children: items.map((item, index) => (_jsxs("dl", Object.assign({ className: style.item() }, { children: [_jsx("dt", Object.assign({ className: style.itemTitle() }, { children: item.title })), _jsx("dt", Object.assign({ className: style.itemDescription() }, { children: item.description }))] }), `HotlineOfferDescription_${index + 1}`))) }))] })));
};
